document.addEventListener("DOMContentLoaded", async function () {
  const homepageContent = document.querySelector(
    "[data-ringo-homepage-content]"
  );

  if (!homepageContent) {
    console.log("Ringo: homepage wrapper not found.");
    return;
  }

  // Create the unavailable notice
  const notice = document.createElement("div");

  notice.className = "ringo-license-page";
  notice.style.display = "none";

  notice.innerHTML = `
    <div class="ringo-license-box">
      <h1>Website Temporarily Unavailable</h1>
      <p class="ringo-license-message">
        Please check back again later.
      </p>
    </div>
  `;

  homepageContent.insertAdjacentElement("beforebegin", notice);

  const configUrl =
    "https://raw.githubusercontent.com/Ringo-dev-s/ringo-license/main/clients/Vobili.json?time=" +
    Date.now();

  try {
    const response = await fetch(configUrl, {
      method: "GET",
      cache: "no-store",
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(
        `GitHub request failed with status ${response.status}`
      );
    }

    const config = await response.json();

    console.log("Ringo GitHub configuration:", config);
    console.log("Ringo enabled value:", config.enabled);
    console.log("Ringo enabled type:", typeof config.enabled);

    if (config.enabled === false) {
      homepageContent.style.setProperty(
        "display",
        "none",
        "important"
      );

      notice.style.setProperty(
        "display",
        "flex",
        "important"
      );

      const messageElement = notice.querySelector(
        ".ringo-license-message"
      );

      messageElement.textContent =
        config.message || "Please check back again later.";

      console.log("Ringo: homepage content disabled.");
    } else {
      homepageContent.style.removeProperty("display");

      notice.style.setProperty(
        "display",
        "none",
        "important"
      );

      console.log("Ringo: homepage content enabled.");
    }
  } catch (error) {
    // Keep the normal homepage visible when GitHub cannot be reached
    homepageContent.style.removeProperty("display");

    notice.style.setProperty(
      "display",
      "none",
      "important"
    );

    console.error("Ringo license check failed:", error);
  }
});